import { render, staticRenderFns } from "./craftsman.vue?vue&type=template&id=404a8aa4&scoped=true&"
import script from "./craftsman.vue?vue&type=script&lang=js&"
export * from "./craftsman.vue?vue&type=script&lang=js&"
import style0 from "./craftsman.vue?vue&type=style&index=0&id=404a8aa4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404a8aa4",
  null
  
)

export default component.exports